import { TasksOptions, TaskStatusWidget } from '@apps-common/apps/portal/pages/units/pages/program-tasks/components'
import { VertSpacerSm } from '@apps-common/components/layout'
import { commonIcons } from '@apps-common/config/icons'
import { toLocalTimestampStr } from '@apps-common/helpers/to-local-timestamp'
import { IAppNavigation } from '@apps-common/hooks/useNavigation'
import { IUnitTaskGroupModel } from '@apps-common/types/portal/unit-tasks'

interface IProps {
  task: IUnitTaskGroupModel
  navigation: IAppNavigation
}

export const TaskCard: React.FC<IProps> = ({ task, navigation }) => {
  const { status, taskType, queueCount, pendingCount, processingCount, failedCount, message } = task

  return (
    <div className='bg-surface text-text border border-border rounded-3xl px-4 py-4 flex flex-col gap-[5px]'>
      <div className='flex items-center justify-between'>
        <div className='grow flex'>
          <div className='flex flex-col gap-[10px]'>
            <TaskStatusWidget status={status} />
            <div className='bg-surface-2 text-text px-4 py-2 h-[20px] rounded-[15px] flex items-center justify-start gap-[10px] min-w-0'>
              <h5 className='jost-light text-[0.85rem] capitalize border border-border'>{taskType?.replaceAll('_', ' ')}</h5>
            </div>
          </div>
        </div>
        <div className='bg-surface-2 rounded-xl flex flex-col gap-[10px] px-3 py-2 grow'>
          {!task.completedAt && (
            <>
              <div className='text-[0.8em]'>Run at</div>
              <div className='text-[0.8em] jost-light'>{task.runAt ? toLocalTimestampStr(task.runAt) : <commonIcons.dash />}</div>
            </>
          )}
          {task.completedAt && (
            <>
              <div className='text-[0.8em]'>Completed at</div>
              <div className='text-[0.8em] jost-light'>{toLocalTimestampStr(task.completedAt)}</div>{' '}
            </>
          )}
        </div>
      </div>
      <VertSpacerSm />
      <div className='flex flex-col'>
        <div className='text-text-muted/70 text-[0.8em] mb-[10px]'>{message}</div>
        <div className='grid grid-cols-2 gap-2'>
          <div className='text-text text-[0.8em] mb-[10px] flex items-center justify-between pr-[10px] gap-[5px] bg-surface-2 rounded-lg'>
            <div className='uppercase bg-surface-2 px-2 py-1 rounded-lg jost-medium'>device(s)</div>
            {queueCount}
          </div>
          <div className='text-text text-[0.8em] mb-[10px] flex items-center justify-between pr-[10px] gap-[5px] bg-surface-2 rounded-lg'>
            <div className='uppercase bg-surface-2 px-2 py-1 rounded-lg jost-medium'>pending</div>
            {pendingCount}
          </div>
          <div className='text-text text-[0.8em] mb-[10px] flex items-center justify-between pr-[10px] gap-[5px] bg-surface-2 rounded-lg'>
            <div className='uppercase bg-surface-2 px-2 py-1 rounded-lg jost-medium'>processing</div>
            {processingCount}
          </div>
          <div className='text-text text-[0.8em] mb-[10px] flex items-center justify-between pr-[10px] gap-[5px] bg-surface-2 rounded-lg'>
            <div className='uppercase bg-surface-2 px-2 py-1 rounded-lg jost-medium'>failed</div>
            {failedCount}
          </div>
        </div>
      </div>
      <VertSpacerSm />
      <TasksOptions task={task} navigation={navigation} />
    </div>
  )
}
